import React from 'react';
import ReactDOM from 'react-dom/client';
import { ReduxCheck } from '../redux-check/ReduxCheck';
import { AudioRecorder } from '../audio-recorder';
import { Asr } from '../asr';
import { Translation } from '../translation';
import { Result } from '../result';
import { useState, useRef } from "react";
import Entity from '../entity/Entity';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const Card = () => {

    return (
        <Container style={{"background": "#f1f1f0"}}>
            <Row>
                <Col>
                    <div className="card-default">
                        <div>
                            <AudioRecorder />
                            <Asr />
                            <Translation />
                            <Entity />      
                            <Result />                      
                        </div>
                    </div>
                </Col>
                {/* <Col></Col> */}
            </Row>
        </Container>

    );
};


export default Card;